import { bl_fi_budget_votebook_item_link_RowClass } from '../../../dbschema/bl_fi_budget_votebook_item_link.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetVotebookItemLinkContainerModel extends BaseContainerModel {
    bl_fi_budget_votebook_item_link: bl_fi_budget_votebook_item_link_RowClass = new bl_fi_budget_votebook_item_link_RowClass();
}
